export default __webpack_public_path__ + "static/media/watermark logo-01.da0c243d.svg";